import { render, staticRenderFns } from "./DefaultFooter.vue?vue&type=template&id=59360338&scoped=true&"
import script from "./DefaultFooter.vue?vue&type=script&lang=js&"
export * from "./DefaultFooter.vue?vue&type=script&lang=js&"
import style0 from "./DefaultFooter.vue?vue&type=style&index=0&id=59360338&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59360338",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59360338')) {
      api.createRecord('59360338', component.options)
    } else {
      api.reload('59360338', component.options)
    }
    module.hot.accept("./DefaultFooter.vue?vue&type=template&id=59360338&scoped=true&", function () {
      api.rerender('59360338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/DefaultFooter.vue"
export default component.exports